// extracted by mini-css-extract-plugin
export var blink = "_styles-module--blink--juOGq";
export var text = "_styles-module--text--A7LUz";